import styled, { css } from 'styled-components';
import { ModalBackdropStyled, Box, ButtonStyled } from '@bechtel/gds';
import { width as userListWidth } from '../styled';

export const listWidth = '288px';
export const DrawerBackdropStyled = styled(ModalBackdropStyled)`
  position: absolute;
  left: ${userListWidth};
  top: 0;
`;

export const DrawerOuterStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  background-color: ${({ theme }) => theme.colors.white};
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: ${listWidth};
`;

export const Header = styled(Box).attrs({
  justifyContent: { sm: 'space-between' },
  pt: { sm: '500' },
  pb: { sm: '400' },
  px: { sm: '500' },
})`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  z-index: 1;
`;

export const ButtonBox = styled(Box).attrs({
  justifyContent: { sm: 'flex-end' },
})`
  ${ButtonStyled} {
    padding: 0 ${({ theme }) => theme.spacings[600]};
  }
`;

export const ResetButtonStyled = styled(Box).attrs({
  px: { sm: '500' },
  py: { sm: '400' },
  my: { sm: '200' },
})`
  ${ButtonStyled} {
    ${({ theme }) => css`
      font-weight: ${theme.fontWeights[600]};
      color: ${theme.colors.blue[800]};
    `}
  }
`;
